import { createSlice } from '@reduxjs/toolkit';


const filterSlice = createSlice({
    name: 'filters',
    initialState: {},
    reducers: {
        setFilterData: (state, action) => {
            const { key, data } = action.payload;
            state[key] = data;
        },
        resetFilterData: (state, action) => {
            const { key } = action.payload;
            state[key] = {};
        }
    }
});

export const { setFilterData, resetFilterData } = filterSlice.actions;

export default filterSlice.reducer;
